import { Component, OnInit, OnDestroy, ViewChild, ChangeDetectorRef, inject } from '@angular/core';
import { ReportingService } from '../reporting.service';
import { EnvironmentService } from '../../services/environment.service';
import { saveAs } from '@progress/kendo-file-saver';
import { AdminService } from '../../admin/admin.service';
import { DashboardService } from '../../dashboard/dashboard.service';
import { GridComponent } from '@progress/kendo-angular-grid';
import { Application, Unit } from '../../models/admin-models';
import { Platform } from '@angular/cdk/platform';
import { SessionStorageService } from '../../services/session-storage.service';
import { dashboardLinks } from '../../lib/toolbar-links';
import { dashboardUtilityApps } from '../../lib/utility-apps';
import { UtilityAppsService } from '../../shared-components/utility-apps/utility-apps.service';

@Component({
  selector: 'app-unified-reporting',
  templateUrl: './unified-reporting.component.html',
  styleUrls: ['./unified-reporting.component.scss'],
  standalone: false,
})
export class UnifiedReportingComponent implements OnInit, OnDestroy {
  private rptSvc = inject(ReportingService);
  private envSvc = inject(EnvironmentService);
  private pltfrm = inject(Platform);
  private dbs = inject(DashboardService);
  private admnSvc = inject(AdminService);
  private ss = inject(SessionStorageService);
  private changeDetector = inject(ChangeDetectorRef);
  private uas = inject(UtilityAppsService);

  @ViewChild('tabGroup') tabGroup;

  baseUrl;
  environment;
  applications: Application[] = [
    { value: 'aw', name: 'Annuity Wizard' },
    { value: 'iw', name: 'Investment Wizard' },
    { value: 'li', name: 'Life Insurance Wizard' },
    { value: 'pp', name: 'Product Profiler' },
    { value: 'rb', name: 'Control KB (RB)' },
  ];

  units: Unit[] = [] as Unit[];
  reportTypes: string[];
  selectedApp;
  selectedType;
  loading = false;
  reportRequestTitle = '';
  reportRequestSubtitle = '';
  dashboardSettings;
  alertIds;
  rights: string[];
  selectedTab = 0;
  navCollapsed = false;
  dashboardLinks = dashboardLinks;

  ngOnInit(): void {
    this.navCollapsed = this.ss.get('utilityToolbarCollapsed');
    this.environment = this.envSvc.get();
    this.baseUrl = this.environment.apiBase;
    this.rights = this.ss.get('rights');

    if (this.rights.includes('ReportRequestPortal')) {
      this.loading = true;
      this.dbs.getDashboardGlobals().subscribe(resp => {
        if (resp['UnitDashboardSettings']) {
          this.dashboardSettings = resp['UnitDashboardSettings'];
        }
        if (resp['AlertIDInfo']) {
          this.alertIds = resp['AlertIDInfo'];
        }
        if (resp['UnitDashboardSettings']['ReportRequestPageTitle']) {
          this.reportRequestTitle =
            resp['UnitDashboardSettings']['ReportRequestPageTitle'];
        }
        if (resp['UnitDashboardSettings']['ReportRequestPageSubtitle']) {
          this.reportRequestSubtitle =
            resp['UnitDashboardSettings']['ReportRequestPageSubtitle'];
        }
        this.loading = false;
      });
    }

    if (
      this.ss.get('defaultReportingTab') &&
      this.ss.get('defaultReportingTab') === 'Unit Usage'
    ) {
      this.selectedTab = 2;
      if (this.rights.includes('ReportRequestPortal')) {
        this.selectedTab = this.selectedTab + 1;
      }
      if (this.rights.includes('LoadHistory')) {
        this.selectedTab = this.selectedTab + 1;
      }
      if (this.rights.includes('UnitProfileHistory')) {
        this.selectedTab = this.selectedTab + 1;
      }
      this.ss.remove('defaultReportingTab');
    }

    this.reportTypes = [];
    this.uas.appsList.set(dashboardUtilityApps);
  }

  ngOnDestroy() {
    this.uas.appsList.set([]);
  }

  unitProfileSelected(ev) {
    const id = ev.selectedRows[0].dataItem.ID;
    const iosSafari =
      this.pltfrm.IOS ||
      (navigator?.['userAgentData']?.platform === 'macOS' &&
        navigator.maxTouchPoints > 1);
    this.rptSvc.getUnitProfileReport(id).subscribe({
      next: data => {
        const filename = `${ev.selectedRows[0].dataItem.KBVersion}.json`;
        let fileData;
        const reader = new FileReader();
        reader.readAsDataURL(data);
        reader.onloadend = () => {
          fileData = reader.result;
          saveAs(fileData, filename, {
            proxyURL: `${this.baseUrl}/util/proxy`,
            proxyTarget: '_self',
            forceProxy: iosSafari,
          });
          // this.loading = false;
        };
      },
      error: error => {
        console.error(error);
      },
    });
  }

  exportToExcel(grid: GridComponent): void {
    grid.saveAsExcel();
  }

  onAppChange() {
    this.admnSvc.getReportTypes(this.selectedApp).subscribe(data => {
      this.reportTypes = data['reportTypes'];
      this.selectedType = this.reportTypes[0];
    });
  }

  toggleNavCollapse() {
    this.navCollapsed = !this.navCollapsed;
  }
}
